import { observer } from 'mobx-react';
import { Component } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import logger from 'src/services/logger';
import wms from 'src/services/wms';
import { downloadFile } from 'src/utils/helpers';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { OrderStore } from '~/mobx/orderStore';
import { withOrderStore } from '~/view/screens/OrderScreen/context';

interface IState {
  loading: boolean;
}

// @ts-ignore
@withOrderStore
@observer
export default class ExportPdfButton extends Component<{ orderStore?: OrderStore }, IState> {
  state = {
    loading: false,
  };

  get orderStore() {
    return this.props.orderStore!;
  }

  export = async () => {
    try {
      if (!this.orderStore.order?.id) return null;

      this.setState({ loading: true });
      if (window.IS_MOBILE) {
        logger.log('-------', `/v3/orders/${this.orderStore.order.id}/pdf`, { params: { file: 0 } });
        const link = await client.get(`/v3/orders/${this.orderStore.order.id}/pdf`, { params: { file: 0 } });
        wms.downloadFile(link);
      } else {
        const blob = await this.orderStore.exportPdf(this.orderStore.order.id);
        downloadFile(blob, `Order ${this.orderStore.order?.order_key}.pdf`);
      }
      this.setState({ loading: false });
    } catch (error: any) {
      this.setState({ loading: false });
      logger.error({ error, place: 'ExportPdfButton export', showModal: true });
    }
  };

  render() {
    return (
      <Button title={localeStore.t('export_to_pdf')} onClick={this.export} loading={this.state.loading} appearance="tertiary" className="mt-4" />
    );
  }
}
